/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Stocktake_Action_CreateInputs */

const vi_stocktake_action_create = /** @type {(inputs: Stocktake_Action_CreateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu`)
};

/**

* @param {Stocktake_Action_CreateInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const stocktake_action_create = /** @type {((inputs?: Stocktake_Action_CreateInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Stocktake_Action_CreateInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_stocktake_action_create(inputs)
});